import * as yup from "yup";
import { definedDecimalStr } from "utils/schemas/decimalStr";
import { formatCurrency } from "utils/formatting";

export const orderingPlatformId = yup.string().required();

export const skuId = yup.string().uuid().required().label("SKU");

export const itemCode = yup
  .string()
  .trim()
  .nullable()
  .defined()
  .default(null)
  .max(50)
  .matches(/^[a-zA-Z0-9-_]+$/, {
    excludeEmptyString: true,
    message:
      "Item code can only contain letters, numbers, hyphens, and underscores.",
  })
  .label("Item Code");

export const wholesaleUnitPrice = definedDecimalStr({
  numberFormatter: formatCurrency,
})
  .min(0)
  .max(10000)
  .label("Wholesale Unit Price");

export const distributionCenterIds = yup
  .array()
  .of(yup.string().uuid().required())
  .ensure()
  .defined()
  .default([])
  .label("Distribution Centers");
